import { isNil, isObject } from 'lodash';

export default class StyleControl {
  SELECTED_ITEM_CSS = ["bg-secondary", "text-white"];

  // @param [Object] style
  // @param [Array<Object>] alternateStyles
  // @param [Object] options
  //   [Function] options.onStyleLoaded
  //   [String] options.title
  //
  constructor({ selectedStyle, alternateStyles = [], mapStyleUrls, options = {} }) {
    if (isNil(selectedStyle))
      throw new Error("Must provide selectedStyle on init");
    if (!isObject(mapStyleUrls))
      throw new Error("Must provide mapStyleUrls object on init");

    this.styles = alternateStyles;
    this.styles.unshift(selectedStyle);
    this.currentStyleName = selectedStyle.name;
    this._mapStyleUrls = mapStyleUrls;
    this._title = options.title;
  }

  onAdd(map) {
    this._map = map;
    this._btn = document.createElement("button");
    this._btn.type = "button";
    this._btn.title = this._title || "Change map theme";
    this._btn.innerHTML = '<i class="fas fa-lg fa-layer-group"/>';
    this._btn.setAttribute('data-toggle', 'collapse');
    this._btn.setAttribute('data-target', '#layer-panel');
    this._btn.onclick = function () {
      this.blur();
    };

    this._listgroup = document.createElement("ul");
    this._listgroup.className = "list-group list-group-flush collapse";
    this._listgroup.id = "layer-panel";
    this._listitems = [];

    // Pattern inspired by comment here:
    // https://github.com/mapbox/mapbox-gl-js/issues/2268#issuecomment-401979967
    const styleLoadCallback = () => {
      const waitForStyleLoad = () => {
        if (!map.isStyleLoaded()) {
          setTimeout(waitForStyleLoad, 200);
        } else {
          map.fire(
            'style.loadcomplete',
            this.styles.find(style => style.name == this.currentStyleName)
          );
          map.off('style.load'. styleLoadCallback);
        }
      };
      waitForStyleLoad();
    };

    this.styles.forEach((style) => {
      let li = document.createElement("li");
      li.className = "list-group-item";
      li.setAttribute("style", "cursor: pointer;");
      li.setAttribute("data-style-url", this._mapStyleUrls[style.map.tile_style]);
      li.setAttribute("data-style-name", style.name);
      li.setAttribute('data-toggle', 'collapse');
      li.setAttribute('data-target', '#layer-panel');
      li.innerHTML = style.name;
      if (this.currentStyleName == style.name) {
        li.classList.add(...this.SELECTED_ITEM_CSS);
      }

      li.onclick = (event) => {
        this._listitems.forEach((item) => {
          item.classList.remove(...this.SELECTED_ITEM_CSS);
        });
        const targetStyle = event.target.getAttribute("data-style-url");
        this.currentStyleName = event.target.getAttribute("data-style-name");

        event.target.classList.add(...this.SELECTED_ITEM_CSS);

        map.fire(
          'style.changeinitiating',
          this.styles.find(style => style.name == this.currentStyleName)
        );

        map.setStyle(targetStyle, { diff: false });

        map.on('style.load', styleLoadCallback);
      };

      this._listitems.push(li);
      this._listgroup.appendChild(li);
    });

    this._container = document.createElement("div");
    this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
    this._container.appendChild(this._btn);
    this._container.appendChild(this._listgroup);

    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }

  enable() {
    this._btn.disabled = false;
  }

  disable() {
    this._btn.disabled = true;
  }
}
